import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Patient } from "../../../utils/api-objects/Patient"
import { Folder } from "../../../utils/Enums"
import { FolderBox } from "./FolderBox"

interface TestProps {
    patient: Patient,
    lastSurveyUpdate: string,
    dnaTracker: { status: string | null, date: string | null },
    bloodTracker: { status: string | null, date: string | null },
    isHealthAssessmentLoading: boolean,
    isDnaLoading: boolean,
    isBloodLoading: boolean,
}

export const TestAndAssessmentBox: React.FC<TestProps> = ({
    patient,
    lastSurveyUpdate,
    dnaTracker,
    bloodTracker,
    isHealthAssessmentLoading,
    isDnaLoading,
    isBloodLoading,
}) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const navigate = useNavigate();

    const handleToggle = () => {
        setIsExpanded(prev => !prev);
    };

    return (
        <div className="space-y-[25px] border rounded-xl p-2 border border-solid border-holifya-grey-shadow shadow-platform-new">
            <div className="font-bold text-[16px] leading-[33px] flex justify-between items-center">
                <span>Test e assessment</span>
                <button
                    onClick={handleToggle}
                    className="text-blue-500 text-sm">
                    {isExpanded ? "Mostra meno" : "Mostra di più"}
                </button>
            </div>
            {isExpanded && (
            <div className="space-y-[20px]">
                <FolderBox
                    folder={Folder.HealthAssessment}
                    pointer={lastSurveyUpdate !== ""}
                    textTwo=""
                    textThree={
                        lastSurveyUpdate !== "" ? `Ultimo aggiornamento: ${lastSurveyUpdate}` : "Non disponibile"
                    }
                    onClick={() => { navigate(`answers?patient_id=${patient.user_id}`) }}
                    isLoading={isHealthAssessmentLoading}
                />
                <FolderBox
                    folder={Folder.DnaTest}
                    pointer={dnaTracker.status === "Risultato ricevuto"}
                    textTwo={(patient.swabcode !== null && !patient.swabcode.startsWith("RESET")) ? patient.swabcode : ""}
                    textThree={
                        dnaTracker.status !== null
                            ? dnaTracker.status === "Risultato ricevuto"
                                ? `${dnaTracker.status}: ${dnaTracker.date}`
                                : dnaTracker.status
                            : "Non disponibile"
                    }
                    onClick={() => { navigate(`dna-test-page?patient_id=${patient.user_id}`) }}
                    isLoading={isDnaLoading}
                />
                <FolderBox
                    folder={Folder.BloodTest}
                    pointer={patient.bloodcodes.length > 0 && bloodTracker.status === "Risultato ricevuto"}
                    textTwo={patient.bloodcodes !== null ? patient.bloodcodes[patient.bloodcodes.length - 1] : ""}
                    textThree={
                        bloodTracker.status !== null
                            ? bloodTracker.status === "Risultato ricevuto"
                                ? `${bloodTracker.status}: ${bloodTracker.date}`
                                : bloodTracker.status
                            : "Non disponibile"
                    }
                    onClick={() => { navigate(`blood-test-page?patient_id=${patient.user_id}`) }}
                    isLoading={isBloodLoading}
                />
            </div>
            )}
        </div>
    )
}